import React from 'react'

export default function FinalRow() {
    return (
        <div className='py-5' style={{}}>


            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 mb-5">
                        <h1 style={{ color: '#A10302' }} className='mb-5'>Our Clients</h1>
                        <div className="row" style={{ border: '1px solid grey' }}>
                            <div className="col-4" style={{ borderRight: '1px solid grey', borderBottom: '1px solid grey' }}>
                                <img width='100%' src="https://wpcharming.com/construction/wp-content/uploads/sites/8/2015/02/logo1.png" alt="" />
                            </div>
                            <div className="col-4" style={{ borderRight: '1px solid grey', borderBottom: '1px solid grey' }}>
                                <img width='100%' src="https://wpcharming.com/construction/wp-content/uploads/sites/8/2015/02/logo2.png" alt="" />
                            </div>
                            <div className="col-4" style={{ borderBottom: '1px solid grey' }}>
                                <img width='100%' src="https://wpcharming.com/construction/wp-content/uploads/sites/8/2015/02/logo3.png" alt="" />
                            </div>
                            <div className="col-4" style={{ borderRight: '1px solid grey' }}>
                                <img width='100%' src="https://wpcharming.com/construction/wp-content/uploads/sites/8/2015/02/logo4.png" alt="" />
                            </div>
                            <div className="col-4" style={{ borderRight: '1px solid grey' }}>
                                <img width='100%' src="https://wpcharming.com/construction/wp-content/uploads/sites/8/2015/02/logo5.png" alt="" />
                            </div>
                            <div className="col-4" style={{}}>
                                <img width='100%' src="https://wpcharming.com/construction/wp-content/uploads/sites/8/2015/02/logo6.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <h1 style={{ color: '#A10302' }} className='mb-5'>Testimonials</h1>
                        <div class="card" style={{ border: '1px solid grey', borderRadius: '0px' }}>

                            <div class="card-body">

                                <p style={{ color: '#8e8e8e' }} class="card-text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. In obcaecati tenetur facere, voluptates provident labore distinctio neque perspiciatis, dolores ipsum commodi aspernatur error repellat sunt! Nemo rerum id recusandae maiores?</p>

                            </div>
                            <div className="card-footer">
                                <div className='d-flex'>
                                    <img width='100px' style={{ borderRadius: '100%' }} src="https://wpcharming.com/construction/wp-content/uploads/sites/8/2015/02/6.jpg" alt="" />
                                    <h3 className='p-4'>James M.Beck</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services copy 5.jsx